import { TasksTable } from '@/features/tasks';
import {
  Panel,
  PanelHeader,
  PanelTitle,
  PanelDescription,
  Link,
  PanelSection,
} from '@customerio/pluma-components/react';
import { useActiveHealthTab } from '../hooks';

export function TasksPanel() {
  const { activeTab } = useActiveHealthTab();

  return (
    <Panel>
      <PanelHeader>
        <PanelTitle>Tasks</PanelTitle>
        <PanelDescription>
          Monitor background tasks, like segment creation and imports, across your workspace.{' '}
          <Link href="https://docs.customer.io/accounts-and-workspaces/workspace-tasks/" isExternal variant="secondary">
            Learn more
          </Link>
        </PanelDescription>
      </PanelHeader>
      <PanelSection withPadding={false}>
        <TasksTable isWorkspaceHealthView={true} isDataTabActive={activeTab === 'data'} />
      </PanelSection>
    </Panel>
  );
}
